<template>
  <div>
    <!-- ===== HEADER ===== -->
    <header id="main-header" class="main-header">
      <div id="above-header" class="above-header d-lg-block wow fadeInDown">
        <div class="header-widget d-flex align-items-center">
          <div class="container">
            <div class="row">
              <div class="col-lg-6 col-12 mb-lg-0 mb-4">
                <div class="widget-left text-lg-left text-center">
                  <aside class="widget widget-contact info1">
                    <div class="contact-area">
                      <div class="contact-icon"><div class="contact-corn"><i class="fas fa-envelope"></i></div></div>
                      <div class="contact-info"><h6 class="title"><a href="#">{{ getConfig('company_email') }}</a></h6></div>
                    </div>
                  </aside>
                  <aside class="widget widget-contact info2">
                    <div class="contact-area">
                      <div class="contact-icon"><div class="contact-corn"><i class="fas fa-phone"></i></div></div>
                      <div class="contact-info"><h6 class="title"><a href="#">{{ getConfig('company_phone') }}</a></h6></div>
                    </div>
                  </aside>
                </div>
              </div>
              <div class="col-lg-6 col-12 mb-lg-0 mb-4">
                <div class="widget-right justify-content-lg-end justify-content-center text-lg-right text-center">
                  <aside class="widget widget-contact info3">
                    <div class="contact-area">
                      <div class="contact-icon"><div class="contact-corn"><i class="fas fa-location-arrow"></i></div></div>
                      <div class="contact-info"><h6 class="title"><a href="#">{{ getConfig('company_address') }}</a></h6></div>
                    </div>
                  </aside>
                  <aside class="widget widget_social_widget third">
                    <ul>
                      <li><a href="#"><i class="fab fa-weibo"></i></a></li>
                      <li><a href="#"><i class="fab fa-qq"></i></a></li>
                      <li><a href="#"><i class="fab fa-tiktok"></i></a></li>
                    </ul>
                  </aside>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="navigation-wrapper">
        <div class="main-navigation-area d-none d-lg-block">
          <div class="main-navigation is-sticky-on">
            <div class="container">
              <div class="row">
                <div class="col-4 my-auto">
                  <div class="logo">
                    <a href="#"><h4 class="site-title">
                      <span class="full-name">{{ getConfig('company_name') || '肯威斯(上海)测试技术有限公司' }}</span>
                      <span class="short-name d-none">肯威斯测试技术</span>
                    </h4></a>
                  </div>
                </div>
                <div class="col-8 my-auto">
                  <nav class="navbar-area">
                    <div class="main-navbar">
                      <ul class="main-menu">
                        <li class="nav-item menu-item"><a class="nav-link" href="#slider-section">公司简介</a></li>
                        <template v-for="st in sectionTypes">
                          <li class="nav-item menu-item menu-item-has-children" v-if="getSectionGroups(st.sectionKey).length > 0" :key="'nav-'+st.typeId">
                            <a class="nav-link" :href="'#section-' + st.sectionKey">{{ st.sectionName }}<span class="sub-menu-toggle"></span></a>
                            <ul class="sub-menu">
                              <li v-for="g in getSectionGroups(st.sectionKey)" :key="'nav-g-'+g.itemId" v-if="g.showInMenu !== '0'">
                                <a :href="'#group-' + g.itemId">{{ g.title }}</a>
                              </li>
                            </ul>
                          </li>
                          <li class="nav-item menu-item" v-else :key="'nav-e-'+st.typeId">
                            <a class="nav-link" :href="'#section-' + st.sectionKey">{{ st.sectionName }}</a>
                          </li>
                        </template>
                        <li class="nav-item menu-item"><a class="nav-link" href="#measure-box">计量专栏</a></li>
                        <li class="nav-item menu-item"><a class="nav-link" href="#news-box">新闻资讯</a></li>
                      </ul>
                    </div>
                    <div class="main-menu-right">
                      <ul class="menu-right-list">
                        <li class="button-area">
                          <a href="#" class="btn btn-primary header-search-toggle" @click.prevent="showCertSearch = true">
                            <span class="btn-label">证书搜索</span><i class="fa fa-search btn-ico"></i>
                          </a>
                        </li>
                        <li class="button-area">
                          <a href="#" class="btn btn-primary btn-like-icon" @click.prevent="showQrcode = true"><span class="btn-label">联系我们</span><i class="fas fa-arrow-right"></i></span></a>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Mobile Nav -->
        <div class="main-mobile-nav is-sticky-on">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="main-mobile-menu">
                  <div class="mobile-logo">
                    <div class="logo"><a href="#"><h4 class="site-title">肯威斯（上海）测试技术有限公司</h4></a></div>
                  </div>
                  <div class="menu-collapse-wrap">
                    <div class="main-menu-right">
                      <ul class="menu-right-list">
                        <li class="button-area">
                          <a href="#" class="btn btn-primary btn-like-icon" @click.prevent="showQrcode = true">联系我们<span class="bticn"><i class="fas fa-arrow-right"></i></span></a>
                        </li>
                      </ul>
                    </div>
                    <div class="hamburger-menu">
                      <button type="button" class="menu-collapsed" aria-label="菜单折叠">
                        <div class="top-bun"></div><div class="meat"></div><div class="bottom-bun"></div>
                      </button>
                    </div>
                  </div>
                  <div class="main-mobile-wrapper">
                    <div id="mobile-menu-build" class="main-mobile-build">
                      <button type="button" class="header-close-menu close-style" aria-label="标题关闭菜单"></button>
                      <ul class="main-menu">
                        <li class="nav-item menu-item"><a class="nav-link" href="#slider-section">公司简介</a></li>
                        <template v-for="st in sectionTypes">
                          <li class="nav-item menu-item menu-item-has-children" v-if="getSectionGroups(st.sectionKey).length > 0" :key="'mnav-'+st.typeId">
                            <a class="nav-link" :href="'#section-' + st.sectionKey">{{ st.sectionName }}<span class="sub-menu-toggle"></span></a>
                            <ul class="sub-menu">
                              <li v-for="g in getSectionGroups(st.sectionKey)" :key="'mnav-g-'+g.itemId" v-if="g.showInMenu !== '0'">
                                <a :href="'#group-' + g.itemId">{{ g.title }}</a>
                              </li>
                            </ul>
                          </li>
                          <li class="nav-item menu-item" v-else :key="'mnav-e-'+st.typeId">
                            <a class="nav-link" :href="'#section-' + st.sectionKey">{{ st.sectionName }}</a>
                          </li>
                        </template>
                        <li class="nav-item menu-item"><a class="nav-link" href="#measure-box">计量专栏</a></li>
                        <li class="nav-item menu-item"><a class="nav-link" href="#news-box">新闻资讯</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div id="content">
      <!-- ===== BANNER SLIDER ===== -->
      <section id="slider-section" class="slider-section owl-nav-1 owl-dot-2 image-move">
        <div class="home-slider owl-carousel owl-theme" ref="owlCarousel">
          <div class="item" v-for="(b, i) in banners" :key="b.bannerId || i">
            <img :src="b.imageUrl">
            <div class="main-slider">
              <div class="main-table">
                <div class="main-table-cell">
                  <div class="container">
                    <div class="main-content" :class="'text-' + (b.textAlign || 'left')">
                      <h4 data-animation="fadeInLeft" data-delay="150ms"><span>{{ b.title }}</span></h4>
                      <h1 data-animation="fadeInRight" data-delay="200ms">{{ b.subTitle }}</h1>
                      <p data-animation="fadeInLeft" data-delay="500ms">{{ b.description }}</p>
                      <a v-if="b.linkUrl" data-animation="fadeInUp" data-delay="800ms" :href="b.linkUrl"
                         class="btn btn-primary btn-like-icon">了解更多<span class="bticn"><i class="fas fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- ===== 动态板块内容（分组模式） ===== -->
      <section v-for="st in sectionTypes" :key="'sec-'+st.typeId" :id="'section-' + st.sectionKey" class="info-section-3 st-py-default">
        <div class="container">
          <!-- 大标题 -->
          <div class="row">
            <div class="col-lg-6 col-12 mx-lg-auto mb-5 text-center">
              <div class="theme-main-heading wow fadeInUp">
                <span class="title"><span class="htdot"></span>{{ st.sectionName }}<span class="htdot"></span></span>
              </div>
            </div>
          </div>
          <!-- 按二级指标题(group)分组 -->
          <template v-for="group in getSectionGroups(st.sectionKey)">
            <!-- 二级标题 -->
            <div :id="'group-' + group.itemId" :key="'group-'+group.itemId" style="margin-bottom:30px;">
              <div class="row" v-if="group.title">
                <div class="col-12 wow fadeInUp" style="margin-bottom:20px;">
                  <h4 style="font-weight:600;color:#333;border-left:4px solid #51a2f5;padding-left:12px;">{{ group.title }}</h4>
                  <p v-if="group.description" style="color:#666;margin-top:8px;">{{ group.description }}</p>
                </div>
              </div>
              <!-- 子图文卡片 -->
              <div class="row" v-if="group.children && group.children.length > 0">
                <div class="col-12 wow fadeInUp">
                  <div class="row g-4 info-wrapper">
                    <div :class="(st.colClass || 'col-lg-4') + ' col-md-6 col-12'" v-for="(item, idx) in group.children" :key="item.itemId">
                      <div class="info-box-inner">
                        <span class="count">{{ String(idx + 1).padStart(2, '0') }}</span>
                        <div class="info-box-icon"><i :class="item.icon || st.icon || 'fas fa-cog'"></i></div>
                        <div class="content-box">
                          <h4 class="info-box-title">{{ item.title }}</h4>
                          <div class="info-content">{{ item.description }}</div>
                          <div style="margin-bottom:10px;overflow:hidden;">
                            <img :src="item.imageUrl" style="width:100%;" v-if="item.imageUrl">
                          </div>
                        </div>
                        <div class="side-border-lines"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 无子项时：将 group 本身当卡片展示 -->
              <div class="row" v-else>
                <div class="col-12 wow fadeInUp">
                  <div class="row g-4 info-wrapper">
                    <div :class="(st.colClass || 'col-lg-4') + ' col-md-6 col-12'">
                      <div class="info-box-inner">
                        <span class="count">01</span>
                        <div class="info-box-icon"><i :class="group.icon || st.icon || 'fas fa-cog'"></i></div>
                        <div class="content-box">
                          <h4 class="info-box-title">{{ group.title }}</h4>
                          <div class="info-content">{{ group.description }}</div>
                          <div style="margin-bottom:10px;overflow:hidden;">
                            <img :src="group.imageUrl" style="width:100%;" v-if="group.imageUrl">
                          </div>
                        </div>
                        <div class="side-border-lines"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </section>


      <!-- ===== 计量专栏 ===== -->
      <section id="measure-box" class="blog-section st-py-default" style="background-color: #f8f9fa;">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-12 mx-lg-auto mb-5 text-center">
              <div class="theme-main-heading wow fadeInUp">
                <span class="title"><span class="htdot"></span>计量专栏<span class="htdot"></span></span>
                <h2 class="subtitle">计量<span class="text-primary">专栏</span></h2>
                <p class="content">专业的计量知识分享，权威的技术解读。</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 wow fadeInUp">
              <div id="measure-list" class="row g-4 blog-wrapper">
                <div class="col-lg-4 col-md-6 col-12" v-for="m in measureList" :key="m.noticeId">
                  <article class="blog-inner static">
                    <div class="blog-item-current">
                      <div class="inner-box">
                        <div class="blog-header">
                          <div class="post-category">
                            <i class="fas fa-book"></i>
                            <span>计量专栏</span>
                          </div>
                        </div>
                        <div class="blog-post-content">
                          <ul class="post-meta list-item">
                            <li class="post-item author"><i class="fas fa-user"></i> {{ m.nickname || 'admin' }}</li>
                            <li class="post-item date"><i class="fas fa-calendar-days"></i> {{ m.createTime }}</li>
                          </ul>
                          <h4 class="post-title">{{ m.noticeTitle }}</h4>
                          <p class="news-main">{{ stripHtml(m.noticeContent) }}</p>
                          <router-link :to="'/measure/' + m.noticeId" class="more-link">详 情</router-link>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-12 text-center">
              <router-link to="/measure" class="btn btn-primary btn-like-icon">查看更多<span class="bticn"><i class="fas fa-arrow-right"></i></span></router-link>
            </div>
          </div>
        </div>
      </section>

      <!-- ===== 新闻资讯 ===== -->
      <section id="news-box" class="blog-section st-py-default">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-12 mx-lg-auto mb-5 text-center">
              <div class="theme-main-heading wow fadeInUp">
                <span class="title"><span class="htdot"></span>新闻资讯<span class="htdot"></span></span>
                <h2 class="subtitle">新闻<span class="text-primary">资讯</span></h2>
                <p class="content">在这里你可以了解到更多关于肯威斯的信息。</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 wow fadeInUp">
              <div id="news-list" class="row g-4 blog-wrapper">
                <div class="col-lg-4 col-md-6 col-12" v-for="n in newsList" :key="n.noticeId">
                  <article class="blog-inner static">
                    <div class="blog-item-current">
                      <div class="inner-box">
                        <div class="blog-header">
                          <div class="post-category">
                            <i class="fas fa-folder"></i>
                            <span>{{ n.noticeType === '1' ? '新闻' : '资讯' }}</span>
                          </div>
                        </div>
                        <div class="blog-post-content">
                          <ul class="post-meta list-item">
                            <li class="post-item author"><i class="fas fa-user"></i> {{ n.nickname || 'admin' }}</li>
                            <li class="post-item date"><i class="fas fa-calendar-days"></i> {{ n.createTime }}</li>
                          </ul>
                          <h4 class="post-title">{{ n.noticeTitle }}</h4>
                          <p class="news-main">{{ stripHtml(n.noticeContent) }}</p>
                          <router-link :to="'/news/' + n.noticeId" class="more-link">阅读更多</router-link>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-12 text-center">
              <router-link to="/news" class="btn btn-primary btn-like-icon">查看更多<span class="bticn"><i class="fas fa-arrow-right"></i></span></router-link>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- ===== FOOTER ===== -->
    <footer>
      <div class="footer-top">
        <div class="container">
          <div class="row g-4 justify-content-center">
            <div class="col-lg-3 col-md-6 col-sm-6 col-12 text-center wow fadeInUp">
              <aside class="widget widget-contact first">
                <div class="contact-area">
                  <div class="contact-icon"><div class="contact-corn"><i class="fa fas fa-envelope"></i></div></div>
                  <div class="contact-info">
                    <h3 class="title">全天候发送电子邮件</h3>
                    <p class="text"><a :href="'mailto:' + getConfig('company_email')">{{ getConfig('company_email') }}</a></p>
                  </div>
                </div>
              </aside>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12 text-center wow fadeInUp">
              <aside class="widget widget-contact first">
                <div class="contact-area">
                  <div class="contact-icon"><div class="contact-corn"><i class="fa fas fa-question"></i></div></div>
                  <div class="contact-info">
                    <h3 class="title">有疑问吗？</h3>
                    <p class="text"><a href="#" @click.prevent="showQrcode = true">联系我们</a></p>
                  </div>
                </div>
              </aside>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12 text-center wow fadeInUp">
              <aside class="widget widget-contact first">
                <div class="contact-area">
                  <div class="contact-icon"><div class="contact-corn"><i class="fa fas fa-phone"></i></div></div>
                  <div class="contact-info">
                    <h3 class="title">全天候致电我们</h3>
                    <p class="text"><a :href="'tel:' + getConfig('company_phone')">{{ getConfig('company_phone') }}</a></p>
                  </div>
                </div>
              </aside>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12 text-center wow fadeInUp">
              <aside class="widget widget-contact first">
                <div class="contact-area">
                  <div class="contact-icon"><div class="contact-corn"><i class="fa far fa-clock"></i></div></div>
                  <div class="contact-info">
                    <h3 class="title">营业时间</h3>
                    <p class="text">周一至周五：08:00 - 16:00</p>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-main st-pt-default">
        <div class="container">
          <div class="row g-4 g-lg-5 justify-content-center">
            <div class="col-lg-6 col-md-6 col-12 wow fadeInUp">
              <aside class="widget widget_text">
                <h5 class="widget-title">快速联系</h5>
                <div class="widget_seperator"><span class="bg-secondary"></span><span class="bg-white"></span><span class="bg-white"></span></div>
                <div class="textwidget">
                  <p>{{ getConfig('footer_description') || '肯威斯公司以"计量服务，服务计量"为使命，以"合规、公正、科学、精准、优质、改进"为方针，期待成为您身边的计量服务专家！' }}</p>
                  <address class="about-addresss">
                    <i class="fa fa-map-marker"></i>{{ getConfig('company_address') }}<br>
                    <i class="fa fa-envelope"></i><a :href="'mailto:' + getConfig('company_email')">{{ getConfig('company_email') }}</a><br>
                    <i class="fa fa-phone"></i><a :href="'tel:' + getConfig('company_phone')">{{ getConfig('company_phone') }}</a>
                  </address>
                </div>
              </aside>
            </div>
            <div class="col-lg-3 col-md-6 col-12 wow fadeInUp">
              <aside class="widget widget_categories">
                <h5 class="widget-title">快速导航</h5>
                <div class="widget_seperator"><span class="bg-secondary"></span><span class="bg-white"></span><span class="bg-white"></span></div>
                <ul>
                  <li class="cat-item"><a href="#slider-section">公司简介</a></li>
                  <template v-for="st in sectionTypes">
                    <li class="cat-item cat-item-has-children" :key="'ft-'+st.typeId" v-if="getSectionGroups(st.sectionKey).filter(g => g.showInMenu !== '0').length > 0">
                      <a :href="'#section-' + st.sectionKey">{{ st.sectionName }}</a>
                      <ul class="sub-menu">
                        <li v-for="g in getSectionGroups(st.sectionKey)" :key="'ft-g-'+g.itemId" v-if="g.showInMenu !== '0'">
                          <a :href="'#group-' + g.itemId">{{ g.title }}</a>
                        </li>
                      </ul>
                    </li>
                    <li class="cat-item" :key="'ft-e-'+st.typeId" v-else>
                      <a :href="'#section-' + st.sectionKey">{{ st.sectionName }}</a>
                    </li>
                  </template>
                  <li class="cat-item"><a href="#measure-box">计量专栏</a></li>
                  <li class="cat-item"><a href="#news-box">新闻资讯</a></li>
                </ul>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-copyright">
        <div class="container">
          <div class="row align-items-center gy-lg-0 gy-4">
            <div class="col-lg-12 col-md-12 col-12 text-center">
              <div class="copyright-text">
                {{ getConfig('copyright') || 'Copyright © 2026 Keyontechs Co.,Ltd. 上海科洋科技股份有限公司 版权所有' }}
                {{ getConfig('icp_number') || '沪ICP备2025120220号' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <!-- Scroll to top -->
    <button type="button" class="scrollingUp scrolling-btn" aria-label="向上滚动" @click="scrollToTop">
      <i class="fas fa-angle-up"></i>
      <svg height="46" width="46"><circle cx="23" cy="23" r="22"></circle></svg>
    </button>

    <!-- 二维码弹窗 -->
    <div id="qrcode-modal" class="qrcode-modal" :class="{ active: showQrcode }">
      <div class="qrcode-modal-overlay" @click="showQrcode = false"></div>
      <div class="qrcode-modal-content">
        <button type="button" class="qrcode-modal-close" @click="showQrcode = false" aria-label="关闭"><i class="fas fa-times"></i></button>
        <div class="qrcode-modal-body">
          <img src="/static/img/qrcode.jpg" alt="联系我们二维码" class="qrcode-image">
          <p class="qrcode-text">扫码联系我们</p>
        </div>
      </div>
    </div>

    <!-- 证书搜索弹窗 -->
    <div id="certificate-result-modal" class="certificate-result-modal" :class="{ active: showCertResult }">
      <div class="certificate-modal-overlay" @click="showCertResult = false"></div>
      <div class="certificate-modal-content">
        <button type="button" class="certificate-modal-close" @click="showCertResult = false" aria-label="关闭"><i class="fas fa-times"></i></button>
        <div class="certificate-modal-header"><h3>证书查询结果</h3></div>
        <div class="certificate-modal-body">
          <div v-if="certLoading" class="certificate-loading">
            <i class="fas fa-spinner fa-spin"></i><p>正在搜索证书信息...</p>
          </div>
          <div v-else-if="certData" class="certificate-success">
            <div class="certificate-success-icon"><i class="fas fa-check-circle"></i></div>
            <table class="certificate-info-table">
              <tr><td>证书编号</td><td>{{ certData.certNo || '-' }}</td></tr>
              <tr><td>CNAS编号</td><td>{{ certData.cnasNo || '-' }}</td></tr>
              <tr><td>校准日期</td><td>{{ certData.calibDate || '-' }}</td></tr>
            </table>
          </div>
          <div v-else-if="certError" class="certificate-warning">
            <div class="certificate-warning-icon"><i class="fas fa-info-circle"></i></div>
            <p>{{ certError }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 证书搜索输入弹窗 -->
    <div id="cert-search-modal" class="qrcode-modal" :class="{ active: showCertSearch }">
      <div class="qrcode-modal-overlay" @click="showCertSearch = false"></div>
      <div class="qrcode-modal-content" style="max-width: 450px">
        <button type="button" class="qrcode-modal-close" @click="showCertSearch = false" aria-label="关闭"><i class="fas fa-times"></i></button>
        <div class="qrcode-modal-body" style="padding: 30px">
          <h4 style="margin-bottom: 20px; text-align: center">证书搜索</h4>
          <form @submit.prevent="doCertSearch">
            <div style="display: flex; gap: 10px">
              <input v-model="certKeyword" type="text" class="form-control" placeholder="请输入证书编号或CNAS编号" style="flex: 1">
              <button type="submit" class="btn btn-primary"><i class="fa fa-search"></i></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBannerList, getSectionTypeList, getSectionItemGrouped, getEquipmentList, getCertificateImgList, getSiteConfigList, getNewsList, getMeasureList, searchCertificate } from '@/api'

export default {
  name: 'Home',
  data() {
    return {
      banners: [],
      sectionTypes: [],       // 所有启用的板块类型
      sectionGroups: {},      // { sectionKey: [groups] } 每个group含title和children
      equipments: [],
      certImgs: [],
      siteConfigs: {},
      newsList: [],
      measureList: [],
      showQrcode: false,
      showCertSearch: false,
      showCertResult: false,
      certKeyword: '',
      certLoading: false,
      certData: null,
      certError: ''
    }
  },
  created() {
    this.loadData()
  },
  mounted() {
    // Init WOW.js
    if (window.WOW) {
      new window.WOW({ live: false }).init()
    }
    this.initStickyAndScroll()
    this.initMobileMenu()
  },
  methods: {
    async loadData() {
      try {
        const [bannerRes, typesRes, eqRes, certImgRes, configRes, newsRes, measureRes] = await Promise.all([
          getBannerList(),
          getSectionTypeList().catch(() => ({ data: [] })),
          getEquipmentList(),
          getCertificateImgList(),
          getSiteConfigList(),
          getNewsList({ pageSize: 3 }).catch(() => ({ data: [] })),
          getMeasureList({ pageSize: 3 }).catch(() => ({ data: [] }))
        ])
        this.banners = bannerRes.data || []
        this.sectionTypes = typesRes.data || []
        // 为每个板块类型加载分组内容（parent_id=0为二级标题，children为图文卡片）
        const groups = {}
        const groupPromises = this.sectionTypes.map(t =>
          getSectionItemGrouped(t.sectionKey).catch(() => ({ data: [] }))
        )
        const groupResults = await Promise.all(groupPromises)
        this.sectionTypes.forEach((t, i) => {
          groups[t.sectionKey] = groupResults[i].data || []
        })
        this.sectionGroups = groups
        this.equipments = eqRes.data || []
        this.certImgs = certImgRes.data || []
        this.newsList = newsRes.rows || newsRes.data || []
        this.measureList = measureRes.rows || measureRes.data || []
        // config -> map
        const configs = configRes.data || []
        const map = {}
        configs.forEach(c => { map[c.configKey] = c.configValue })
        this.siteConfigs = map
        // Init owl carousel after data ready
        this.$nextTick(() => { this.initOwlCarousel() })
      } catch (e) {
        console.error('加载数据失败', e)
      }
    },
    getSectionGroups(sectionKey) {
      return this.sectionGroups[sectionKey] || []
    },
    getConfig(key) {
      return this.siteConfigs[key] || ''
    },
    stripHtml(html) {
      if (!html) return ''
      return html.replace(/<[^>]*>/g, '')
    },
    async doCertSearch() {
      if (!this.certKeyword.trim()) {
        this.certError = '请输入证书编号或CNAS编号'
        this.certData = null
        this.certLoading = false
        this.showCertSearch = false
        this.showCertResult = true
        return
      }
      this.certLoading = true
      this.certData = null
      this.certError = ''
      this.showCertSearch = false
      this.showCertResult = true
      try {
        const res = await searchCertificate(this.certKeyword.trim())
        if (res.found) {
          this.certData = res
        } else {
          this.certError = res.msg || '未找到相关证书信息'
        }
      } catch (e) {
        this.certError = '搜索失败，请稍后重试'
      }
      this.certLoading = false
    },
    initOwlCarousel() {
      const $ = window.jQuery
      if ($ && $.fn.owlCarousel) {
        var $owl = $(this.$refs.owlCarousel)
        $owl.owlCarousel({
          items: 1,
          loop: true,
          autoplay: true,
          autoplayTimeout: 10000,
          margin: 0,
          nav: true,
          dots: false,
          navText: ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>'],
          singleItem: true,
          transitionStyle: 'fade',
          touchDrag: true,
          mouseDrag: true,
          responsive: { 0: { nav: false }, 768: { nav: false }, 992: { nav: true } }
        })
        // Slide animation handling
        $owl.on('translate.owl.carousel', function() {
          $('[data-animation]').each(function() {
            var anim = $(this).data('animation')
            $(this).removeClass('animated ' + anim).css('opacity', '0')
          })
        })
        $owl.on('translated.owl.carousel', function() {
          $owl.find('.owl-item.active [data-animation]').each(function() {
            var anim = $(this).data('animation')
            $(this).addClass('animated ' + anim).css('opacity', '1')
          })
        })
        // Set delay styles
        $('[data-delay]').each(function() { $(this).css('animation-delay', $(this).data('delay')) })
        // Trigger first slide animation
        setTimeout(function() {
          $owl.find('.owl-item.active [data-animation]').each(function() {
            var anim = $(this).data('animation')
            $(this).addClass('animated ' + anim).css('opacity', '1')
          })
        }, 100)
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    initStickyAndScroll() {
      const $ = window.jQuery
      if (!$) return
      // Sticky header on scroll
      $(window).on('scroll', function() {
        if ($(window).scrollTop() >= 250) {
          $('.is-sticky-on').addClass('is-sticky-menu')
        } else {
          $('.is-sticky-on').removeClass('is-sticky-menu')
        }
        // Scroll to top button
        if ($(window).scrollTop() > 200) {
          $('.scrollingUp').addClass('is-active')
        } else {
          $('.scrollingUp').removeClass('is-active')
        }
      })
      // Scroll to top circle animation
      $(window).on('scroll', function() {
        if ($('.scrollingUp').length) {
          var b = $('body').height(), c = $(window).height(), d = b - c, e = $(window).scrollTop()
          var f = 250 - e / d * 150
          $('.scrollingUp circle').css('stroke-dashoffset', f + 'px')
        }
      })
    },
    initMobileMenu() {
      const $ = window.jQuery
      if (!$) return
      // Hamburger menu toggle
      $(document).on('click', '.menu-collapsed', function() {
        $('body').toggleClass('header-menu-active overlay-enabled')
        $(this).toggleClass('collapsed')
        if ($('body').hasClass('header-menu-active')) {
          $('.header-close-menu').focus()
        }
      })
      // Close menu
      $(document).on('click', '.header-close-menu', function() {
        $('body').removeClass('header-menu-active overlay-enabled')
        $('.menu-collapsed').removeClass('collapsed')
      })
      // Click outside to close
      $(document).on('click', function(e) {
        var $target = $(e.target)
        if (!$target.closest('.menu-collapsed').length && !$target.closest('.main-mobile-build').length) {
          if ($('body').hasClass('header-menu-active')) {
            $('body').removeClass('header-menu-active overlay-enabled')
            $('.menu-collapsed').removeClass('collapsed')
          }
        }
      })
    }
  }
}
</script>

<style>
#news-box .news-main, #measure-box .news-main {
  height: 80px;
  overflow: hidden;
  line-height: 1.5;
  position: relative;
  margin-bottom: 15px;
}
#news-box .news-main::after, #measure-box .news-main::after {
  content: '';
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 20px;
  background: linear-gradient(transparent, rgba(255,255,255,0.9));
}
/* ===== 图片统一自适应 ===== */
/* ===== 卡片统一尺寸 ===== */
.service-image-box {
  width: 100%;
  aspect-ratio: 4/3;
}
.service-image-box .service-img,
.info-box-inner img[style],
.feature-single-item > div > img {
  width: 100%;
  overflow: hidden;
  display: block;
}
.service-image-box img,
.info-box-inner img,
.feature-single-item > div > img {
  width: 100%;
  height: auto;
  max-height: 380px;
  object-fit: contain;
  object-position: center;
}
/* 文字区域固定高度 + 超出省略 */
.info-box-inner .info-content {
  height: 72px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.info-box-inner .info-box-title {
  height: 28px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* 现场检校卡片文字固定 */
.service-inner-box-2 .service-excerpt {
  height: 60px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.service-inner-box-2 .service-title {
  height: 28px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* 弹窗通用布局 */
.qrcode-modal, .certificate-result-modal { display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; }
.qrcode-modal { z-index: 10000; }
.certificate-result-modal { z-index: 10001; }
.qrcode-modal.active, .certificate-result-modal.active { display: block; }
.qrcode-modal-overlay, .certificate-modal-overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); }
.certificate-modal-overlay { backdrop-filter: blur(4px); }
.qrcode-modal-content { position: absolute !important; top: 50% !important; left: 50% !important; transform: translate(-50%, -50%) !important; width: 90%; max-width: 400px; background: #fff; border-radius: 16px; box-shadow: 0 20px 60px rgba(0,0,0,0.3); overflow: hidden; }
.certificate-modal-content { position: relative; width: 90%; max-width: 700px; margin: 5vh auto; background: #fff; border-radius: 16px; box-shadow: 0 20px 60px rgba(0,0,0,0.3); overflow: hidden; }
.qrcode-modal-close, .certificate-modal-close { position: absolute; top: 15px; right: 15px; width: 36px; height: 36px; border: none; background: rgba(0,0,0,0.05); border-radius: 50%; font-size: 18px; cursor: pointer; z-index: 10; }
.qrcode-modal-body { padding: 30px; text-align: center; }
.qrcode-image {  width: 100%; border-radius: 8px; }
.qrcode-text { margin-top: 15px; font-size: 16px; color: #333; }
.certificate-modal-close { position: absolute; top: 20px; right: 20px; width: 40px; height: 40px; border: none; background: rgba(0,0,0,0.05); border-radius: 50%; font-size: 20px; cursor: pointer; z-index: 10; }
.certificate-modal-header { padding: 30px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; }
.certificate-modal-header h3 { margin: 0; font-size: 24px; font-weight: 600; }
.certificate-modal-body { padding: 30px; max-height: 500px; overflow-y: auto; }
.certificate-loading { text-align: center; padding: 40px 20px; color: #666; }
.certificate-loading i { font-size: 40px; color: #667eea; margin-bottom: 15px; }
.certificate-success-icon { text-align: center; margin-bottom: 25px; }
.certificate-success-icon i { font-size: 60px; color: #4caf50; }
.certificate-info-table { width: 100%; border-collapse: collapse; background: #f8f9fa; border-radius: 8px; overflow: hidden; }
.certificate-info-table tr { border-bottom: 1px solid #e0e0e0; }
.certificate-info-table tr:last-child { border-bottom: none; }
.certificate-info-table td { padding: 15px 20px; }
.certificate-info-table td:first-child { font-weight: 600; color: #333; width: 140px; background: rgba(102,126,234,0.08); }
.certificate-warning { text-align: center; padding: 40px 20px; }
.certificate-warning-icon i { font-size: 60px; color: #ff9800; }
.certificate-warning p { font-size: 16px; color: #666; line-height: 1.6; }

/* ===== 快速导航二级菜单：默认隐藏，hover 展开 ===== */
.widget_categories ul > .cat-item-has-children > .sub-menu {
  display: none;
  list-style: none;
  margin: 0;
  padding: 2px 0 4px 14px;
}
.widget_categories ul > .cat-item-has-children:hover > .sub-menu,
.widget_categories ul > .cat-item-has-children:focus-within > .sub-menu {
  display: block;
}
.widget_categories ul > .cat-item-has-children > .sub-menu li {
  padding: 3px 0;
}
.widget_categories ul > .cat-item-has-children > .sub-menu a {
  font-size: 0.9em;
  opacity: 0.85;
}
.widget_categories ul > .cat-item-has-children > .sub-menu a:hover {
  opacity: 1;
  color: var(--bs-primary, #51a2f5);
}
</style>
